export default "__VITE_ASSET__H9iBEg32__"